import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as mediaContentApi from "../../../api/mediaContent";

export function useMediaContents() {
  return useQuery({
    queryKey: ["mediaContents"],
    queryFn: () => mediaContentApi.fetchAll(),
  });
}

export function useSaveMediaContent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => mediaContentApi.saveOrUpdate(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["mediaContents"] }),
  });
}

export function useMediaFileNames() {
  return useQuery({
    queryKey: ["mediaFileNames"],
    queryFn: () => mediaContentApi.fetchAllMediaFileNames(),
  });
}
